<template>
        <v-toolbar
          color="blue lighten-1"     
          fixed
          dark
          flat
          app
          :clipped-left="clip"
        >
          <img
            src="../assets/nicechats.png"
            contain
            width="38"
            height="38"
          >
          <span class="ml-2 font-weight-regular title">NiceChat</span>
          
          <v-toolbar-items class="ml-5" v-if="needMenu">
            <v-menu class="ml-5" flat offset-y>
              <template v-slot:activator="{ on }">
                <v-btn flat
                  dark
                  class="text-capitalize title font-weight-regular ml-4"
                  v-on="on"
                >
                   <v-avatar size="32px">
                    <img
                      :src="currentbot.imageurl"
                      :alt="currentbot.name"
                    >
                  </v-avatar>
                  <span class="ml-2">{{currentbot.name}}</span>
                  <v-icon>arrow_drop_down</v-icon>
                </v-btn>
              </template>
                <v-list>
                  <v-list-tile
                    v-for="(bot, index) in botsList"
                    :key="index"
                    @click="selectBot(bot.id)"
                  >
                    <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu> 
          </v-toolbar-items>
          
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">          
            <v-btn icon large v-on="on"
              >
              <v-avatar size="32px">
                <img
                  :src="profilePic"
                  :alt="displayname"
                >
              </v-avatar>
            </v-btn>
            </template>
            <span>{{providerdata}}<br>{{displayname}}<br>{{mailid}}</span>          
          </v-tooltip>
          <v-toolbar-items class="ml-0 text-lowercase font-weight-regular">
              <v-btn flat @click="signpoutFirebase" class="text-capitalize title font-weight-regular">Logout</v-btn>
          </v-toolbar-items>
    </v-toolbar>
</template>

<script>
import Vue from 'vue';
import firebase from 'firebase';
import fb from '../plugins/fb.js';

export default {
  data(){
    return{
      clip:true,
      settoolbar:true,
      page_id:this.$route.params.page_id,
      bots:null,
      profilePic:firebase.auth().currentUser.photoURL,
      displayname:firebase.auth().currentUser.displayName,
      mailid:firebase.auth().currentUser.email,
      providerdata:firebase.auth().currentUser.providerData[0].providerId
    }
  },
  methods:{
    signpoutFirebase()
    {
      firebase.auth().signOut();
    },
    selectBot(pageid){
      let route = this.$route.name
      let s_menu_value = this.$route.params.s_menu
      this.$router.push('/'+route+'/'+s_menu_value+'/'+pageid)
      this.$store.dispatch('aFetchfbdata')
      this.$store.dispatch('aFetchpagedata', pageid)
      this.$store.dispatch('aSelectedPage',pageid)
      this.$store.dispatch('afetchresponses')
      this.$store.dispatch('afetchrules')
      this.$store.dispatch('afetchassets')
      this.$store.dispatch('afetchBTemplates')
    },
  },
  computed:{
    botsList(){ 
    this.bots = this.$store.state.botsList
    console.log(this.bots)
    return this.bots
    },
    currentbot(){
      let p_id = this.$route.params.page_id
      let l_bots = this.$store.state.botsList
      if (l_bots != null) {
      let index = l_bots.findIndex(x => x.id == p_id) 
      if(index != -1){
      return l_bots[index]
      }
      else {
        return {"name":"Loading..", "imageurl":firebase.auth().currentUser.photoURL}
        }
      }
     },
     needMenu(){
       let r_name = this.$route.name
       if (r_name == 'dashboard' || r_name == 'settings-newbot'){
          return false
       }
        else
       {
          return true
       }
     }
  },
  created(){

  }
}
</script>
